export default __webpack_public_path__ + "static/archivivo-0f5a81e0a21a288e8e85718d406dd6e2.png";